import type { FC, PropsWithChildren } from 'react';
import { Header } from '@/components/Header.tsx';
import { ApplicationProvider } from '@/contexts/ApplicationContext';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ApplicationProvider>
      <div className="min-h-screen bg-background">
        <Header />

        <div className="flex flex-col justify-self-center items-center w-full pt-8">
          {children}
        </div>
      </div>
    </ApplicationProvider>
  );
};
